/* eslint-disable @typescript-eslint/ban-types */
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { NextPageContext } from 'next';

import { getAccountSectionData } from 'Services/api/account';
import { logger } from 'Services/logger/logger';
import type { DateRangeFilterValue } from 'Types/account';
import type { VehicleAccountListItem } from 'Types/vehicle';

export type AccountVehicleListParams = {
	category: string;
	keyword?: string;
	limit: number;
	offset: number;
	purchasesCompleteStatusType?: string;
	slug: string;
} & DateRangeFilterValue;

type UseAccountVehicleListPayload = {
	context?: NextPageContext;
	initialData?: UseAccountVehicleListApi;
	keepPreviousData?: boolean;
	params: AccountVehicleListParams;
};

export type UseAccountVehicleListApi = { count: number; results: Array<VehicleAccountListItem> };

export const ACCOUNT_VEHICLE_LIST_QUERY_KEY: string = 'accountVehicleList';

export const useAccountVehicleList = ({
	context,
	initialData,
	keepPreviousData = false,
	params,
}: UseAccountVehicleListPayload): UseQueryResult<UseAccountVehicleListApi> =>
	useQuery({
		initialData,
		keepPreviousData,
		onError: (e) => {
			const message = `There was an issue with fetching vehicles in ${params.category} category for ${params.slug}`;
			const error = e instanceof Error ? e : new Error(message);
			logger.error({ context: { extra: { info: message } }, error, message, scope: 'useAccountVehicleList' });
		},
		queryFn: () => getAccountSectionData(params, context),
		queryKey: [ACCOUNT_VEHICLE_LIST_QUERY_KEY, params],
	});
